// Mirror of flexcoa-api Caregiver.validate_pin (flexcoa_api/models/caregiver/base.py).
// Keep these rules in sync — the backend re-validates and will reject anything
// that slips through here, but matching client-side keeps the UX honest.

const SIMPLE_SEQUENCES = new Set([
  '123456', '234567', '345678', '456789', '567890',
  '987654', '876543', '765432', '654321', '543210',
]);

export function validateCaregiverPin(rawPin, caregiverId = null) {
  const pin = String(rawPin ?? '').trim();
  if (!pin) return 'PIN is required.';
  if (pin.length < 6) return 'PIN must be at least 6 characters.';
  if (/^(\d)\1{5,}$/.test(pin)) return 'PIN cannot be the same digit repeated.';
  if (SIMPLE_SEQUENCES.has(pin)) return 'PIN cannot be a simple sequence like 123456.';
  if (/^\d+$/.test(pin) && pin.length >= 6) {
    const digits = pin.split('').map(Number);
    const ascending = digits.every((d, i) => i === 0 || d - digits[i - 1] === 1);
    const descending = digits.every((d, i) => i === 0 || digits[i - 1] - d === 1);
    if (ascending || descending) {
      return 'PIN cannot be a consecutive sequence.';
    }
  }
  if (caregiverId && pin === String(caregiverId).trim()) {
    return 'PIN cannot match your Caregiver ID.';
  }
  return null;
}

export const PIN_REQUIREMENTS_HINT =
  'At least 6 characters. Avoid simple patterns like 123456 or repeated digits.';
